import React, { useState } from 'react';
import { IStoryViewMessages } from '../../../../../types';
import { ConfirmationModal } from '../../../../common/components/ConfirmationModal';
import { useRemoveBudgetAndProposalsInStory } from '../../hooks';

interface IRemoveBudgetConfirmationModalProps {
  messages: IStoryViewMessages;
  storyId: string;
  setRemoveBudget(removeBudget: boolean): void;
  onBudgetRemoved(): Promise<void>;
}

export const RemoveBudgetConfirmationModal = ({
  messages,
  storyId,
  setRemoveBudget,
  onBudgetRemoved
}: IRemoveBudgetConfirmationModalProps) => {
  const [isDeletingBudget, setIsDeletingBudget] = useState<boolean>(false);
  const { mutate: doRemoveBudget } = useRemoveBudgetAndProposalsInStory();

  const handleBudgetRemove = () => {
    setIsDeletingBudget(true);
    doRemoveBudget(
      { storyId },
      {
        onSuccess: () => void onBudgetRemoved(),
        onSettled: () => {
          setIsDeletingBudget(false);
          setRemoveBudget(false);
        }
      }
    );
  };

  return (
    <ConfirmationModal
      title={messages.removeBudget}
      description={messages.removeBudgetDesc}
      dataTest="delete-menu-confirmation-modal"
      confirmationRequired={true}
      actionPending={isDeletingBudget}
      confirmationText={messages.remove}
      confirmationButtonVariant="destructive"
      onCancel={() => !isDeletingBudget && setRemoveBudget(false)}
      onProceed={handleBudgetRemove}
    />
  );
};
